import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_system_bar = _resolveComponent("v-system-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, {
    id: "v-app",
    app: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_navigation_drawer, {
            "expand-on-hover": "",
            permanent: "",
            "z-index": "200",
            theme: _ctx.userStore.mode==='light'?'dark':'light',
            rail: "",
            "onUpdate:rail": _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleNavbarCollapse($event)))
          }, {
            append: _withCtx(() => [
              _createVNode(_component_v_list, {
                dense: "",
                nav: "",
                opened: _ctx.navBarUserGroup,
                "onUpdate:opened": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.navBarUserGroup) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_divider),
                  (!_ctx.loggedIn)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 0,
                        href: _ctx.loginUrl(),
                        "prepend-icon": "mdi-login",
                        title: _ctx.i18n.t('buttons.signin')
                      }, null, 8, ["href", "title"]))
                    : _createCommentVNode("", true),
                  (_ctx.loggedIn)
                    ? (_openBlock(), _createBlock(_component_v_list_group, { key: 1 }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_list_item, _mergeProps(props, {
                            "prepend-icon": "mdi-account-circle-outline",
                            title: _ctx.userStore.userInfo.givenName,
                            subtitle: _ctx.userStore.userInfo.familyName
                          }), null, 16, ["title", "subtitle"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            "prepend-icon": "mdi-account-cog-outline",
                            title: "User settings",
                            disabled: ""
                          }),
                          _createVNode(_component_v_list_item, {
                            "prepend-icon": "mdi-logout",
                            title: _ctx.i18n.t('buttons.signout'),
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logout()))
                          }, null, 8, ["title"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["opened"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list, {
                dense: "",
                nav: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    "two-line": "",
                    "prepend-avatar": require('@/assets/white_polteqe.png'),
                    title: 'Polteq ID',
                    subtitle: _ctx.i18n.t('app.title')
                  }, null, 8, ["prepend-avatar", "subtitle"]),
                  _createVNode(_component_v_divider),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routerlinks.values(), (item) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      key: item.title,
                      link: "",
                      href: item.ref,
                      "prepend-icon": item.icon,
                      title: item.title
                    }, null, 8, ["href", "prepend-icon", "title"]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_v_spacer)
            ]),
            _: 1
          }, 8, ["theme"]),
          _createVNode(_component_v_system_bar, {
            theme: _ctx.userStore.mode==='light'?'dark':'light'
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("a", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.i18n.locale.value = 'nl'))
                }, "NL"),
                _cache[5] || (_cache[5] = _createTextVNode(" | ")),
                _createElementVNode("a", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.i18n.locale.value = 'en'))
                }, "EN"),
                _cache[6] || (_cache[6] = _createTextVNode("      "))
              ])
            ]),
            _: 1
          }, 8, ["theme"]),
          _createVNode(_component_v_main, {
            "max-height": "90vh",
            style: {"overflow-y":"auto"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}